import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../Generated/RestClient";

export interface LogStreamProps extends React.Props<LogStream> {
    logs: string;
}

export interface LogStreamState {
}


export class LogStream extends React.Component<LogStreamProps, LogStreamState> {
    private pre: HTMLPreElement;

    constructor(props: LogStreamProps) {
        super(props);
        this.state = {
            logs: ''
        }
    }

    public componentDidUpdate(prevProps: LogStreamProps, prevState: LogStreamState) {
        //auto scroll log stream to the latest
        const $logstream = $(this.pre);
        const scrollHeight = $logstream[0].scrollHeight;

        if (_.isNumber(scrollHeight) && scrollHeight > $logstream.height() + $logstream.scrollTop()) {
            $('.log-stream').scrollTop($logstream[0].scrollHeight - $logstream.height());
        }
    }

    public render(): JSX.Element {
        return (
            <pre className="log-stream" ref={ x => this.pre = x}>
                {this.props.logs}
            </pre>
        );
    }
}


// WEBPACK FOOTER //
// ./Client/Views/LogStream.tsx